import { useI18nContext } from "@hopper-b2b/i18n";
import Warning from "../../../assets/client/warning.svg";
import "./index.scss";

interface IFlightCalendarDateLabelProps {
  label: string;
  icon: string;
  dateSelected: string;
  warning?: boolean;
}

export const DateLabelWarning = () => {
  const { t } = useI18nContext();
  return (
    <div className="calendar-date-label-warning">
      <img src={Warning} className="warning-icon" alt="warning" />
      <p className="label-warning-text">{t("mobileSearchChooseDateWarning")}</p>
    </div>
  );
};

export const FlightCalendarDateLabel = ({
  label,
  dateSelected,
  icon,
  warning = false,
}: IFlightCalendarDateLabelProps) => {
  return (
    <div className="flight-calendar-date-label">
      <img className="airplane-icon" src={icon} alt="" />
      <div className="date-content">
        <h4 className="date-label">{label}</h4>
        <p className="date-selected">
          {warning ? <DateLabelWarning /> : dateSelected}
        </p>
      </div>
    </div>
  );
};
